// extracted by mini-css-extract-plugin
export default {"root":"SplitScreen-module-root-cwIA7","left":"SplitScreen-module-left-Xn5tJ","right":"SplitScreen-module-right-ME8Ot"};